import { createContext, useContext, useState } from "react";

const HeaderTitleContext = createContext();

export const HeaderTitleProvider = ({ children }) => {
  const [title, setTitle] = useState("");

  return (
    <HeaderTitleContext.Provider value={{ title, setTitle }}>
      {children}
    </HeaderTitleContext.Provider>
  );
};

export const useHeaderTitle = () => {
  const context = useContext(HeaderTitleContext);
  if (!context) {
    throw new Error("useHeaderTitle must be used within HeaderTitleProvider");
  }
  return context;
};
